/**
 * i18n.js
 *
 * This will setup the i18n language files and locale data for your app.
 *
 *   IMPORTANT: This file is used by the internal build
 *   script `extract-intl`, and must use CommonJS module syntax
 *   You CANNOT use import/export in this file.
 */

const enTranslationMessages = require('./translations/en.json');
const arTranslationMessages = require('./translations/ar.json');
const koTranslationMessages = require('./translations/ko.json');

const DEFAULT_LOCALE = 'en';

const lang = {
  en: 'en',
  ko: 'ko',
};

// prettier-ignore
const appLocales = [
  'en',
  'ar',
  "ko",
];

const formatTranslationMessages = (locale, messages) => {
  console.log(`로케일: ${locale}`);
  const defaultFormattedMessages =
    locale !== DEFAULT_LOCALE
      ? formatTranslationMessages(DEFAULT_LOCALE, enTranslationMessages)
      : {};
  const flattenFormattedMessages = (formattedMessages, key) => {
    const formattedMessage =
      !messages[key] && locale !== DEFAULT_LOCALE
        ? defaultFormattedMessages[key]
        : messages[key];
    return Object.assign(formattedMessages, { [key]: formattedMessage });
  };
  return Object.keys(messages).reduce(flattenFormattedMessages, {});
};

const translationMessages = {
  en: formatTranslationMessages('en', enTranslationMessages),
  ar: formatTranslationMessages('ar', arTranslationMessages),
  ko: formatTranslationMessages('ko', koTranslationMessages),
};

const t = (key, locale = lang.ko) => {
  const messages = translationMessages[locale] || {};
  return messages[key] || key;
};

exports.appLocales = appLocales;
exports.formatTranslationMessages = formatTranslationMessages;
exports.translationMessages = translationMessages;
exports.DEFAULT_LOCALE = DEFAULT_LOCALE;
exports.t = t;
exports.lang = lang;
